<a
  *ngIf="icon"
  type="button"
  mdbBtn
  tabindex="0"
  [floating]="floating"
  [outline]="outline"
  [size]="size"
  [color]="color"
  [classList]="class"
  [mdbTooltip]="tooltip"
  (click)="handleClick($event)"
  (keyup.enter)="handleClick()"
>
  <mdb-icon *ngIf="outline" fas [size]="size" [icon]="icon" [class]="'text-' + color" style="margin-top: -1.5px; margin-left: -1.5px"></mdb-icon>
  <mdb-icon *ngIf="!outline" fas [size]="size" [icon]="icon"></mdb-icon>
</a>
